export default class AEEList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/c_order/aee')

		for (let entry of data) {
			if (typeof entry.state === 'string') {
				entry.state = JSON.parse(entry.state)
			}
		}

		return new AEEList(data)
	}

	getById (id) {
		return this.index[id]
	}
}
